import detechtionLogoDarkPng from "@assets/DetechtionLogo-dark.png";
import detechtionLogoLightPng from "@assets/DetechtionLogo-light.png";

/**
 * Dark-theme Detechtion.AI wordmark (white + red).
 * Prefer {@link getDetechtionLogoSrc} when theme is known.
 */
export const DETECHTION_LOGO_SRC = detechtionLogoDarkPng;

/** Light-theme Detechtion.AI wordmark (slate + red). */
export const DETECHTION_LOGO_LIGHT_SRC = detechtionLogoLightPng;

/**
 * Theme-aware Detechtion.AI wordmark.
 * @param {"light"|"dark"|string} [theme]
 * @returns {string}
 */
export function getDetechtionLogoSrc(theme = "light") {
  return theme === "dark" ? detechtionLogoDarkPng : detechtionLogoLightPng;
}

const ENBASE_NAME_RE = /\benbase\b/i;

/** Enbase org tenant id from the session list (display-name heuristic, once per list). */
export function resolveEnbaseTenantId(availableTenants) {
  if (!availableTenants?.length) return null;
  return (
    availableTenants.find((t) => ENBASE_NAME_RE.test(t.displayName ?? ""))
      ?.tenantId ?? null
  );
}

/** True when the tenant is the Enbase org (tenant id when known, else display name). */
export function isEnbaseTenant(tenant, enbaseTenantId = null) {
  if (!tenant) return false;
  if (enbaseTenantId != null) return tenant.tenantId === enbaseTenantId;
  return ENBASE_NAME_RE.test(tenant.displayName ?? "");
}
